import type { ComputedRef, InjectionKey } from 'vue';

export type BrandThemeName =
  | 'accadisHSTheme'
  | 'accadisISBTheme'
  | 'accadisBITheme';

export interface BrandThemeDefinition {
  colors: { navbg: string; navtext: string; menuheadertext: string };
  assets: { logo: string; defaultNewsImg: string };
}

export const DEFAULT_BRAND_THEME: BrandThemeName = 'accadisHSTheme';

export const brandThemes: Record<BrandThemeName, BrandThemeDefinition> = {
  accadisHSTheme: {
    colors: { navbg: '#004c93', navtext: '#ffffff', menuheadertext: '#7d7d7d' },
    assets: { logo: '/img/logo-hs.svg', defaultNewsImg: '/img/hs-news-default.webp' },
  },
  accadisISBTheme: {
    colors: { navbg: '#F9B122', navtext: '#ffffff', menuheadertext: '#7d7d7d' },
    assets: { logo: '/img/logo-isb.svg', defaultNewsImg: '/img/isb-news-default.webp' },
  },
  accadisBITheme: {
    colors: { navbg: '#DEDEDE', navtext: '#7d7d7d', menuheadertext: '#7d7d7d' },
    assets: { logo: '/img/logo-bi.svg', defaultNewsImg: '/img/hs-default.jpg' },
  },
};

export function resolveBrandThemeName(
  name: string | null | undefined
): BrandThemeName {
  return name && Object.hasOwn(brandThemes, name)
    ? (name as BrandThemeName)
    : DEFAULT_BRAND_THEME;
}

export function brandThemeStyle(name: BrandThemeName): Record<string, string> {
  const { colors } = brandThemes[name];
  return {
    '--color-navbg': colors.navbg,
    '--color-navtext': colors.navtext,
    '--color-menuheadertext': colors.menuheadertext,
  };
}

export const brandThemeKey: InjectionKey<ComputedRef<BrandThemeName>> =
  Symbol('brandTheme');
